$(document).ready(function() {

    // Quicknavi Toggle
    $("body").on("click", 'h3.ttgUKQuickNaviHeading', function() {
        $(".ttgQuickNaviBuchenFlyout").slideToggle();
    });

    // Kinderfeld ggf. entfernen
    // Formular abschicken
    $("#ttgBookingBoxSubmitBtn").click(function() {
        if ($("#children").val() == "") {
            $("#children").remove();
        }
        $("#ttgBuchenForm").submit();
    });

    // Datepicker
    if ($(".ttgFeratelMultiLayout").length) {
        // nichts machen
    } else {
        if ($(".ttgBuchenBoxDatepicker").length) {
            $(".ttgBuchenBoxDatepicker").datepicker({
                minDate: 0,
                firstDay: 1,
                dateFormat: 'dd.mm.yy',
                gotoCurrent: true,
                onSelect: function(dateText, inst) {
                    getCalculatedEndDate(dateText);
                }
            });
        }
    }

    // Datum per default befüllen
    $("#anreiseDatum").val(getTomorrow());
    $("#selArrivalDate").val(getTomorrow("feratel"));

});

function getArrivalDate(dateText) {
    var anreiseDatumTmp = selectedDate;
    var anreiseDatumString = anreiseDatumTmp.split(".");
    $("#selArrivalDate").val(anreiseDatumString[2] + anreiseDatumString[1] + anreiseDatumString[0]);

}

function getCalculatedEndDate(selectedDate) {
    var anreiseDatumTmp = selectedDate;
    var anreiseDatumString = anreiseDatumTmp.split(".");
    var anreiseDatum = new Date(anreiseDatumString[2], anreiseDatumString[1], anreiseDatumString[0]);
    //anreiseDatum.setDate(anreiseDatum.getDate() + parseInt($("#nights").val()));
    var endDateDay = (anreiseDatum.getDate().toString().length < 2) ? '0' + anreiseDatum.getDate() : anreiseDatum.getDate();
    var endDateMonth = (anreiseDatum.getMonth().toString().length < 2) ? '0' + anreiseDatum.getMonth() : anreiseDatum.getMonth();
    var endDate = endDateDay + '.' + endDateMonth + '.' + anreiseDatum.getFullYear(); // String mit addierem Datum
    $("#selArrivalDate").val(anreiseDatumString[2] + anreiseDatumString[1] + anreiseDatumString[0]);
}

function calculateEndDate() {
    var today = getTomorrow();
    if ($("#anreiseDatum").val() == today) {
        $("#anreiseDatum").val(today);
    } else {
        // nichts machen
    }
    var anreiseDatumTmp = $("#anreiseDatum").val();
    var anreiseDatumString = anreiseDatumTmp.split(".");
    var anreiseDatum = new Date(anreiseDatumString[2], anreiseDatumString[1], anreiseDatumString[0]);
    //anreiseDatum.setDate(anreiseDatum.getDate() + parseInt($("#nights").val()));
    var endDateDay = (anreiseDatum.getDate().toString().length < 2) ? '0' + anreiseDatum.getDate() : anreiseDatum.getDate();
    var endDateMonth = (anreiseDatum.getMonth().toString().length < 2) ? '0' + anreiseDatum.getMonth() : anreiseDatum.getMonth();
    var endDate = endDateDay + '.' + endDateMonth + '.' + anreiseDatum.getFullYear(); // String mit addierem Datum
    $("#abreiseDatum").val(endDate);
}

function getTomorrow(type) {
    var heute = new Date();
    var morgen = new Date(heute.getTime() + 86400000); // plus ein Tag
    var monat = ((morgen.getMonth() + 1).toString().length < 2) ? '0' + (morgen.getMonth() + 1) : (morgen.getMonth() + 1);
    var tag = (morgen.getDate().toString().length < 2) ? '0' + morgen.getDate() : morgen.getDate();

    var jahr = morgen.getFullYear();
    var jetzt = new Date();
    if (type == "feratel") {
        return jahr + "" + monat + "" + tag;
    } else {
        return tag + "." + monat + "." + jahr;
    }
}